import type { useNotification } from '@/hooks';

export const getMenuLink = ({
  businessId,
  outletId,
  tableId,
}: {
  businessId: string;
  outletId?: string;
  tableId?: string;
}) => {
  const segments = [];
  for (const [key, value] of [
    ['b', businessId],
    ['o', outletId],
    ['t', tableId],
  ]) {
    if (value) {
      segments.push(key, value);
    } else {
      break;
    }
  }

  return '/' + segments.join('/');
};

export const copyLinkToClipboard = async (
  link: string,
  message?: string,
  showNotification?: ReturnType<typeof useNotification>['showNotification']
) => {
  await navigator.clipboard.writeText(link);
  showNotification?.({
    message: message || 'Link copied to clipboard',
    severity: 'success',
    duration: 2000,
  });
};

export const getInviteLink = (invitationCode: string) => {
  return `${window.location.origin}/login?invite=${invitationCode}`;
};

export const getEmailVerificationUrl = () => {
  const currentUrl = new URL(window.location.href);
  currentUrl.pathname = '/email-verification';
  return currentUrl.toString();
};
